import axios from 'axios'

const test = require('./test');
// const Qs = require('qs');
const base64 = require('./base64.min')
//cookie
import cookie from "./cookie";
// 服务器地址（按环境切换请求域名）
const apiHost = process.env.NODE_ENV === 'production'
  ? 'https://fd.fangsk.com'
  : 'http://fangsk.1.y01.cn';
const apiPrefix = `${apiHost}/api`;
const key = "123456";

const login = () => import('@/common/js/login.js');

// 引入提示
import {Toast} from 'vant';
import {Dialog} from 'vant';

// In-flight request dedupe: same method/url/payload shares one promise.
const pendingRequestMap = new Map();

function normalizeData(value) {
  if (value === null || value === undefined) return value;
  if (Array.isArray(value)) return value.map(normalizeData);
  if (Object.prototype.toString.call(value) === '[object Object]') {
    const sorted = {};
    Object.keys(value).sort().forEach((key) => {
      sorted[key] = normalizeData(value[key]);
    });
    return sorted;
  }
  return value;
}

function getRequestKey(method, url, data) {
  return [method, url, JSON.stringify(normalizeData(data || {}))].join('::');
}

function withDedupe(method, url, data, requestFactory) {
  const key = getRequestKey(method, url, data);
  if (pendingRequestMap.has(key)) {
    return pendingRequestMap.get(key);
  }
  const requestPromise = requestFactory().finally(() => {
    pendingRequestMap.delete(key);
  });
  pendingRequestMap.set(key, requestPromise);
  return requestPromise;
}

// http request 拦截器（所有发送的请求都要从这儿过一次），通过这个，我们就可以把token传到后台，我这里是使用sessionStorage来存储token等权限信息和用户信息，若要使用cookie可以自己封装一个函数并import便可使用
axios.interceptors.request.use(
  config => {
    //设置跨域头部,虽然很多浏览器默认都是使用json传数据，但咱要考虑IE浏览器。
    config.headers = {
      // 'Content-Type':'application/json'
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    // 拼接URL，避免出现重复斜杠
    const requestPath = String(config.url || '').replace(/^\/+/, '');
    config.url = `${apiPrefix}/${requestPath}`;
    // 把data转换为FormData格式且加密
    config.transformRequest = [function (data) {
      // 已经为FormData格式则不用加密
      if (data instanceof FormData) {
        return data;
      } else {
        let req = new FormData();
        req.append('data', base64.base64_encode(test.authcode(encodeURI(JSON.stringify(config.data)), 'ENCODE', key)));
        return req;
      }
    }]
    return config;
  },
  err => {
    return;
  }
);

// http response 服务器响应拦截器
axios.interceptors.response.use(
  response => {
    // Loading.close();    /* 移除loading */
    if (response.data.code == 0) {  //登录
      cookie.delCookie('uid');
      login();
    }
    return response;
  },
  error => {
    // Loading.close();    /* 移除loading */
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
  return withDedupe('GET', url, params, () => {
    return new Promise((resolve, reject) => {
      axios.get(url, {
        params: params
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err)
        })
    })
  });
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  const isFormData = Object.prototype.toString.call(data) === '[object FormData]';
  if (isFormData) {
    data.append('uid', cookie.getCookie('uid'));
  } else {
    data.uid = cookie.getCookie('uid');
    data.login_type = 1;
  }

  if (isFormData) {
    return new Promise((resolve, reject) => {
      axios.post(url, data).then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
    })
  }

  return withDedupe('POST', url, data, () => {
    return new Promise((resolve, reject) => {
      axios.post(url, data).then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
    })
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(response => {
      resolve(response.data);
    }, err => {
      reject(err)
    })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(response => {
      resolve(response.data);
    }, err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/common/js/http.js